module.exports = __webpack_public_path__ + "static/media/binamra_khadkha.7d598e2b.jpg";